module.exports = __webpack_public_path__ + "static/media/login-header-640x430.7e6eee96.jpg";